import { render, staticRenderFns } from "./OfferAlternativeDates.vue?vue&type=template&id=5ae1b7fc&"
import script from "./OfferAlternativeDates.vue?vue&type=script&lang=js&"
export * from "./OfferAlternativeDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae1b7fc')) {
      api.createRecord('5ae1b7fc', component.options)
    } else {
      api.reload('5ae1b7fc', component.options)
    }
    module.hot.accept("./OfferAlternativeDates.vue?vue&type=template&id=5ae1b7fc&", function () {
      api.rerender('5ae1b7fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/OfferAlternativeDates.vue"
export default component.exports